const isGtagAvailable = () => {
  return typeof window !== "undefined" && typeof window.gtag === "function";
};

export const grantConsent = ({ analytics, marketing }) => {
  if (!isGtagAvailable()) return;
  const analyticsConsent = analytics ? "granted" : "denied";
  const marketingConsent = marketing ? "granted" : "denied";
  window.gtag("consent", "update", {
    ad_storage: marketingConsent,
    ad_user_data: marketingConsent,
    ad_personalization: marketingConsent,
    analytics_storage: analyticsConsent,
  });
};

export const trackEvent = ({ action, category, label, value }) => {
  if (!isGtagAvailable()) return;
  window.gtag("event", action, {
    category: category,
    label: label,
    value: value,
  });
};

export const trackPageView = (url) => {
  if (!isGtagAvailable()) return;
  window.gtag("event", "page_view", {
    page_path: url,
  });
};

// Fires the "generate_lead" conversion on a confirmed successful form
// submission. Pushes a single object-shape event to window.dataLayer - GTM
// (container GTM-MSG7KHKN) is the only consumer, configured on Favoured's
// side to build the GA4 + Google Ads conversion tags off this event.
// enhancedConversionData carries raw (un-hashed) contact details - GTM's own
// tag hashes these client-side before anything is sent.
export const pushLeadConversion = ({
  formId,
  formName,
  formLocation,
  enquiryType,
  leadId,
  enhancedConversionData,
} = {}) => {
  if (typeof window === "undefined") return;

  const eventData = {
    event: "generate_lead",
    form_id: formId,
    form_name: formName,
    form_location: formLocation,
    page_path: window.location.pathname,
    page_url: window.location.href,
    ...(enquiryType ? { enquiry_type: enquiryType } : {}),
    ...(leadId ? { lead_id: leadId } : {}),
    ...(enhancedConversionData
      ? { enhanced_conversion_data: enhancedConversionData }
      : {}),
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventData);
};
